import { useConsultationType } from '@/hooks/useConsultationType'
import { CONSULTATION_TYPE } from '@/types/consultation'

import { InputForm } from './InputForm'
import { MentalForm } from './MentalForm/index.tsx'
import { PrescriptionForm } from './PrescriptionForm'

export const Landing = () => {
  const { consultationType } = useConsultationType()

  let FormComponent = <InputForm />
  if (consultationType === CONSULTATION_TYPE.PRESCRIPTION) {
    FormComponent = <PrescriptionForm />
  } else if (consultationType === CONSULTATION_TYPE.ASSESSMENT) {
    FormComponent = <MentalForm />
  }

  return (
    <div className="flex flex-1 flex-col p-4" data-testid="landing-container">
      {FormComponent}
    </div>
  )
}
